//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

// npm packages
import React, { useEffect, useContext, useState } from "react";
import { useHistory } from "react-router-dom";

// custom pages
import Context from "context/context";
import access from "config/access";
import PointsCard from "./Components/PointsCard";
import AvailablePointsCard from "./Components/AvailablePointsCard";
import { useStyles } from "./styles";
import { useTranslation } from 'react-i18next';

// material-ui
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Button from '@material-ui/core/Button';
import audit from 'apis/audit/audit';
import * as moment from 'moment';
import {useTrackWithGTM} from 'helpers/gtm'

//analytics
import { logEvent } from "../../../helpers/analytics";
import TierProgress from "./Components/TierProgress";

export default function MyDashboard() {
  const { state, dispatch } = useContext(Context);
  const history = useHistory();
  const classes = useStyles();
  const { t, i18n } = useTranslation();
  const [faqDialogOpen, setFaqDialogOpen] = useState(false);
  const [expanded, setExpanded] = React.useState('');
    const [open, setOpen] = useState(true);
    const { createdormantnotification } = audit();
   
    const { trackWithGTM } = useTrackWithGTM()
  useEffect(() => {
    dispatch({ type: "SET_PATHNAME", payload: ["HOME"] });
  }, []);


  useEffect(() => {
  
  
    // 🔹 Log page view
    logEvent({
      event_type: "page_view",
      event_name: "MyDashboard",
      user_id: state?.userInfo?.user_id,
      session_id: state?.userInfo?.session_id,
    });
  }, []);

  
  useEffect(() => {
    handleMarketingAdminFunc();
  }, [state.ALA]);

  const handleMarketingAdminFunc = () => {
    if (access["myDashboard"]["loyalty"][state.userInfo.role]) {
      if (state?.ALA && Object.keys(state?.ALA).length > 0) {
        return;
      }
      return history.push("/dashboard/loyalty");
    }
  };

  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };

  const handleFaqDialogOpen = () => {
    setFaqDialogOpen(true);
  };
  const handleFaqDialogClose = () => {
    setFaqDialogOpen(false);
    setExpanded('')
    trackWithGTM({
      database: state?.userInfo?.loyalty_organization_name,
      event: "click",
      pathname: window.location.pathname,
      userId: state?.userInfo?.user_id,
      role_id:state?.userInfo?.role_id
    });
  };

  const handleCreateResponse = async () => {
    try {
    
      let values;
      values = {
        id:state?.ALA?.loyalty_id
      };
       let res = await createdormantnotification(values);
       if(res.data){
        sessionStorage.setItem("ispopclosed", "true");
        
       }

     
    } 
    catch (e) {
      console.log({ e });
    }
  };

  const org = state?.userInfo?.loyalty_organization_name;

  const raw = state?.userInfo?.riskDateResult; // e.g. "June 28, 2025"
  const riskdate =  moment(raw).format("MMMM D, YYYY");

  

 

  return (
    <div>
      <PointsCard loyaltyId={state?.ALA?.loyalty_id} />
      <AvailablePointsCard
        loyaltyActive={state?.ALA?.["Loyalty_Account.is_active"]}
      />
       {open && state?.userInfo?.loyalty_organization_name === 'Henry Schein Dental' && state?.userInfo?.dormantstatus && sessionStorage.getItem('ispopclosed')==null  ? (
        <div
          style={{
            position: "fixed",
            top: 0, left: 0, right: 0, bottom: 0,
            background: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            textAlign:"center",
            zIndex: 1000
          }}
        >
          <div
            style={{
              background: "#fff",
              height: "350px",
              width: "500px",
              padding: "20px",
              borderRadius: "8px",
              position: "relative",
            }}
          >
            <CloseIcon
              style={{
                position: "absolute",
                top: "10px",
                right: "10px",
                cursor: "pointer",
              }}
              onClick={() => {
                handleCreateResponse();
                setOpen(false);
              }}
            />

            <p style={{ margin: "31px", fontSize: "19px" }}>
              <b>Heads up!</b> You haven't redeemed any points in over 23 months.
              To keep your full points balance and <b>protect your member benefits (including tiered service discounts),</b>
              redeem any amount by <b>{riskdate}.</b>
              (Note: This is separate from 'points due to expire'.)
              
            </p>

            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                setOpen(false);
                setTimeout(() => {
                  history.push('/dashboard/redeem');
                }, 200);
                handleCreateResponse()
                trackWithGTM({
                  database: state?.userInfo?.loyalty_organization_name,
                  event: "click",
                  pathname: window.location.pathname,
                  userId: state?.userInfo?.user_id,
                  role_id:state?.userInfo?.role_id
                });
              }}
              style={{ marginTop: "10px" }}
            >
              Redeem My Points
            </Button>

            <div style={{ marginTop: "16px" }}>
              <a
                style={{ textDecoration: "underline", cursor: "pointer" }}
                onClick={() => {
                  handleCreateResponse();
                  setOpen(false);
                }}
              >
                Skip to Dashboard
              </a>
            </div>
          </div>
        </div>
      ):null}
      {/* {org == "Henry Schein Dental" && <button className={classes.faqBtn} onClick={handleFaqDialogOpen}>
        {t('System Outage FAQs')}
      </button>} */}
      {(state?.userInfo?.role_id == 10 || state?.userInfo?.role_id == 13) && 
        state?.userInfo?.loyalty_organization_name == 'Henry Schein Dental' && 
        (!state?.ACA?.signature_flag && !state?.ACA?.startup_flag) &&
        <TierProgress purchases={state?.ALA?.current_tier_points} tierName={state?.ALA?.["Loyalty_Account.tier"]} />
      }
      <Dialog
        open={faqDialogOpen}
        keepMounted
        aria-describedby='alert-dialog-slide-description'
        fullWidth
        maxWidth='md'
        disableBackdropClick
      >
        <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title" className={classes.accordionHeading}>
          <b>{t('Thrive Rewards FAQs on System Outage')}</b>
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleFaqDialogClose}
          className={classes.clsBtn}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent>
          <DialogContentText id='alert-dialog-slide-description'>
            <Accordion defaultExpanded expanded={expanded === 'panel1'} onChange={handleChange('panel1')}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1-content"
                id="panel1-header"
              >
                <Typography className={classes.accordionQuestionTypography}>
                  Q1: Did I earn Thrive Rewards points for orders that were placed during the loyalty outage?
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography>
                  Yes, you earned Thrive Rewards points for orders placed during the loyalty outage, including orders that
                  qualified for promotional points.
                </Typography>
              </AccordionDetails>
            </Accordion>
            <Accordion expanded={expanded === 'panel2'} onChange={handleChange('panel2')}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel2-content"
                id="panel2-header"
              >
                <Typography className={classes.accordionQuestionTypography}>
                  Q2: Where can I see these points on my Thrive Rewards account?
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography>
                  You can view all of your points in the &#39;View My Activity&#39; section of your Thrive Rewards account.
                </Typography>
              </AccordionDetails>
            </Accordion>
            <Accordion expanded={expanded === 'panel3'} onChange={handleChange('panel3')}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel3-content"
                id="panel3-header"
              >
                <Typography className={classes.accordionQuestionTypography}>
                  Q3: What happens to any points I had expiring in October, November, and December?
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography>
                  We are reissuing points that expired in October, November, and December 2023. These will be
                  deposited as a single courtesy transaction with an extended expiration date of March 2, 2024. This will
                  allow you to redeem any points expired during this period.
                </Typography>
              </AccordionDetails>
            </Accordion>
            <Accordion expanded={expanded === 'panel4'} onChange={handleChange('panel4')}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel4-content"
                id="panel4-header"
              >
                <Typography className={classes.accordionQuestionTypography}>
                  Q4: Will there be any changes in how I can redeem my points?
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography>
                  Yes, there is a temporary change. Normally, you can redeem points against qualifying sales over the
                  prior 90 days. To restore any missed redemption opportunities caused by the platform being
                  inaccessible, we are widening the qualifying sales period temporarily for redemptions from prior 90 days
                  to prior 180 days.
                </Typography>
              </AccordionDetails>
            </Accordion>
            <Accordion expanded={expanded === 'panel5'} onChange={handleChange('panel5')}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel5-content"
                id="panel5-header"
              >
                <Typography className={classes.accordionQuestionTypography}>
                  Q5: Who can I contact for more information or if I have further questions?
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography>
                  For any additional inquiries or clarifications, please reach out to your Field Sales Consultant or call
                  1-800-888-6684.
                </Typography>
              </AccordionDetails>
            </Accordion>
          </DialogContentText>
        </DialogContent>        
      </Dialog>
    </div>
  );
}
